/* Judge.me preview-badge stars → scroll to the review widget.
 *
 * Horizon scrolls inside .page-wrapper at ≥990px (html/body are overflow:hidden),
 * so Judge.me's own $('html,body').animate({scrollTop}) silently no-ops on desktop.
 * jdgmSettings.scrollTo is Judge.me's sanctioned override hook: their jdgm.scrollTo
 * calls it first and skips its own scroll when the hook returns false.
 * scrollIntoView targets the nearest scrollable ancestor, so one code path covers
 * the .page-wrapper scroller on desktop and the window scroller on mobile.
 */
(function () {
  'use strict';

  function scrollToReviews(target) {
    /* Reviews sit behind a chevron (custom-pdp-sections.js): open it first,
       or the widget is hidden and there is nothing to scroll to. */
    var box = document.getElementById('ccc-reviews');
    if (box && !box.open) box.open = true;
    var el = target && target.jquery ? target[0] : target;
    if (el && el.offsetParent === null) el = null; // hidden target (e.g. inside a collapsed section)
    if (!el) {
      var candidates = document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetParent !== null) {
          el = candidates[i];
          break;
        }
      }
    }
    if (!el || !el.scrollIntoView) return false;

    var headerH = 0;
    var header = document.querySelector('#header-group .shopify-section');
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') headerH = header.getBoundingClientRect().height;
    }
    el.style.scrollMarginTop = Math.round(headerH + 16) + 'px';
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return false; // tells Judge.me to skip its html/body animate
  }

  /* jdgmSettings arrives async from Judge.me's loader and may be rebuilt while it
   * boots, so keep re-asserting the hook for the first 30s instead of setting once. */
  var iv = setInterval(function () {
    if (window.jdgmSettings && window.jdgmSettings.scrollTo !== scrollToReviews) {
      window.jdgmSettings.scrollTo = scrollToReviews;
    }
  }, 250);
  setTimeout(function () {
    clearInterval(iv);
  }, 30000);
})();
